"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.design = void 0;
exports.design = function (axios) {
    return {
        // 디자인 부가 설정 조회
        getExtraDesigns: function (_a) {
            var params = _a.params;
            return axios.get('designs/extra-infos/icons', { params: params });
        },
        // 디자인 부가 설정
        putExtraDesigns: function (_a) {
            var data = _a.data;
            return axios.put('designs/extra-infos/icons', data);
        },
        // 디자인 상품 공통 설정 조회
        getExtraProductsDesigns: function (_a) {
            var params = _a.params;
            return axios.get('designs/extra-infos/products', { params: params });
        },
        // 디자인 상품 공통 설정 수정
        putExtraProductsDesigns: function (_a) {
            var data = _a.data;
            return axios.put('designs/extra-infos/products', data);
        },
        // 스킨 꾸미기 설정 조회
        getDesignsExtraInfosDecorations: function (_a) {
            var params = _a.params;
            return axios.get('designs/extra-infos/decorations', { params: params });
        },
        // 스킨 꾸미기 설정 저장
        putDesignsExtraInfosDecorations: function (_a) {
            var data = _a.data;
            return axios.put('designs/extra-infos/decorations', data);
        }
    };
};
